'use strict';

const isMobile = require('../../modules/util/isMobile');
let stateAlreadySet = false;

const initEvents = function(){

    const elixirOutOfStock = $('.js-out-of-stock-btn[data-sticky-type="elixir"]');
    const elixirs = $('.js-product-details-content .js-options-dropdown-custom');
    if (elixirOutOfStock.length && !elixirOutOfStock.attr('style')){
        $('.js-sticky-add-to-cart').hide();
        $('.js-product-details-content .js-personalized-name').attr('disabled',true);
    }
    handleBackToHairTemple();

    handleSelectedElixirs(elixirs);
    // click on swatch - should replace product content with new variant
    $('body').on('click', '.js-swatch-anchor-option', function (e) {
        e.preventDefault();
        // if not selectable, do nothing
        if ($(this).hasClass('swatch__anchor--unselectable')){
            return;
        }

        // update content
        updateContent($(this));

        if ($('.js-sticky-add-to-cart').length > 0){
            updateStickyContent($(this));
        }
    });
    $(document).on('click', '.js-sticky-add-to-cart .js-pdp-select-size-btn, .js-sticky-add-to-cart .js-select-elixir', function(){
        const scrollTopOffset = isMobile() ? $('.js-product-details-content').offset().top : 0;
            $('html, body').animate({scrollTop: scrollTopOffset}, 'slow');
    });

    $('body').on('change', '.js-options-dropdown', function(){
        const $this = $(this);
        // get option li element in PDP main content

        const optionPdpElement = $('ul[data-optionid="' + $this.data('optionid') + '"]').find('li[value=' + $this.val() + '] a');

        updateContent(optionPdpElement);
        updateStickyContent(optionPdpElement);
    });

    $('body').on('change', '.js-product-details-content .js-options-dropdown-custom', function(){
        const $this = $(this);
        const form = $this.parents('form');
        const validator = $(form).validate();
        const options = form.find('.js-options-dropdown-custom');
        const name = form.find('.js-personalized-name');

        const val = $this.val();
        const otherSelect = jQuery.grep(options, function(value) {
            return value.name !== $this.attr('name');
        });
        disableAlreadySelected($(otherSelect), val);

        if (checkOutOfStock(options)){
            validator.resetForm();
            handleOutOfStock(name);
            return;
        }
        name.removeAttr('disabled');
        handleFieldValidation($this, validator);
    });

    $('body').on('input', '.js-product-details-content .js-personalized-name', function(){
        const $this = $(this);
        const charNumnberLabel = $this.nextAll('.js-charnumber');
        const maxlength = parseInt($this.attr('maxlength'), 10);
        const labelText = maxlength - $this.val().length;
        charNumnberLabel.text(labelText < 0 ? 0 : labelText);
        handleFieldValidation($this, $this.parents('form').validate());
    });

    $('body').on('click', '.js-product-details-content .js-add-to-cart', function(e){
        const $this = $(this);
        const form = $this.parents('form');
        if (form.valid()){
            $this.removeClass('btn--disabled');
            return true;
        }
        $this.addClass('btn--disabled');
        e.preventDefault();
        e.stopPropagation();
    });

    if ($('.js-options-dropdown-custom').length || $('.js-personalized-name').length){
        $(window).on('beforeunload', setState);
        $(window).on('unload', setState);
        $(document).on('pagehide', setState);
    }
};

const disableAlreadySelected = function(option, value){
    option.find('.disabled-selected').removeClass('disabled-selected').removeAttr('disabled');
    option.find('[value="' + value + '"]').addClass('disabled-selected').attr('disabled', true);
    option.selectric('refresh');
};

const updateContent = function (element) {
    const parentListItem = element.parent('li');
    const optionValue = parentListItem.attr('value');
    const parentList = parentListItem.parent('ul');
    parentList.find('li').each(function() {$(this).removeClass('selected');});
    parentListItem.addClass('selected');

    if ($('.quickview-popup').length > 0) {
        $('.quickview-popup .js-options-hidden-input').val(optionValue);
        $('.quickview-popup .js-disabled-add-to-cart').hide();
        $('.quickview-popup .js-add-to-cart').show();
    } else {
        $('.js-options-hidden-input').val(optionValue);
        $('.js-options-dropdown').hide();
        $('.js-disabled-add-to-cart').hide();
        $('.js-add-to-cart').show();
    }
};

const enableAddToCart = function(){
    $('.js-product-details-content .js-add-to-cart').removeClass('btn--disabled').show();
    $('.js-sticky-add-to-cart-form .js-disabled-add-to-cart').hide();
    $('.js-sticky-add-to-cart-form .js-add-to-cart').show().removeClass('btn--disabled');
    enableDisableSocialCommerce(true);
};

function enableDisableSocialCommerce(enable) {
    const $socialCommerceButton = $('.js-product-details-content .js-social-commerce-button');
    if (!$socialCommerceButton || !$socialCommerceButton.length) {
        return;
    }

    if (enable) {
        $socialCommerceButton.parent().removeClass('hide');
        return;
    }

    $socialCommerceButton.parent().addClass('hide');
}

const disableAddToCart = function(){
    $('.js-product-details-content .js-add-to-cart').addClass('btn--disabled');
    $('.js-sticky-add-to-cart-form .js-disabled-add-to-cart').show();
    $('.js-sticky-add-to-cart-form .js-add-to-cart').hide().addClass('btn--disabled');
    enableDisableSocialCommerce();
};

const handleOutOfStock = function(nameEl){
    nameEl.attr('disabled', true);
    $('.js-product-details-content .js-add-to-cart').addClass('btn--disabled').show();
    $('.js-sticky-add-to-cart-form .js-disabled-add-to-cart').hide();
    $('.js-sticky-add-to-cart-form .js-add-to-cart').addClass('btn--disabled').show();
    enableDisableSocialCommerce();
    return;
};

const checkOutOfStock = function(){
    const selected = $('.js-product-details-content option.js-out-of-stock-option:selected');
   return selected.length > 0;
};

const handleFieldValidation = function(element, validator){
    if (element.valid() && validator.checkForm()){
        enableAddToCart();
        return;
    }
    disableAddToCart();
};

const updateStickyContent = function(element){
    const parentListItem = element.parent('li');
    const formattedValue = parentListItem.data('formattedvalue');
    const $priceElement = $('.js-sticky-price-container');

    $priceElement.empty().append('<div class="product-price">' + formattedValue + '</div>');
};

function setState(){
    if (stateAlreadySet) {
        return;
    }
    stateAlreadySet = true;
    const state = history.state || {};
    state.hairtemple = true;
    history.replaceState(state, '', location.href);
    return;
}

function handleBackToHairTemple(){
    if (history.state && history.state.hairtemple && window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD){
        if (checkOutOfStock()){
            handleOutOfStock($('.js-product-details-content .js-personalized-name'));
            return;
        }
        if ($('.js-product-details-content form').valid()){
            enableAddToCart();
            return;
        }
        disableAddToCart();
    }
}

function handleSelectedElixirs(elixirs){
    elixirs.each(function(){
        const $this = $(this);
        const val = $this.val();
        const otherSelect = jQuery.grep(elixirs, function(value) {
            return value.name !== $this.attr('name');
        });
        disableAlreadySelected($(otherSelect), val);
    });
}

module.exports = function () {
    initEvents();
};
